"use client";
import { useSession } from "next-auth/react";
import Header from "@/app/components/Header";
import Sidebar from "@/app/components/Sidebar";

export default function AuthWrapper({ children }) {
  const {  data:session, status } = useSession();

  
  if (status === "loading") return <div></div>;

  return session ? (
    <>
      <Header />
      <Sidebar>{children}</Sidebar>
    </>
  ) : (
       <>{children}</>
  );
}
